import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import GlobalProvider from "../context/store";
import PrivateRoute from "../hoc/PrivateRoute/privateRoute";

// Routes
import Dashboard from "./Dashboard/dashboard";
import Articles from "./Articles/articles";
import ArticleCreate from "./Articles/article-create";
import ArticleEdit from "./Articles/article-edit";
import Jobs from "./Jobs/jobs";
import JobCreate from "./Jobs/job-create";
import JobEdit from "./Jobs/job-edit";
import Members from "./Members/members";
import Media from "./Media/media";
import Login from "./Login/login";
import Error from "./Error/error";

// Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faBars,
  faSignOutAlt,
  faUser,
  faCog,
  faHome,
  faNewspaper,
  faPhotoVideo,
  faCalendarAlt,
  faUsers,
  faChild,
  faCloud,
  faPlus,
  faPaperPlane,
  faArrowLeft,
  faTimes,
  faIdCard,
  faTrashAlt,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import Downloads from "./Downloads/downloads";

library.add(
  fab,
  faBars,
  faSignOutAlt,
  faUser,
  faCog,
  faHome,
  faNewspaper,
  faPhotoVideo,
  faCalendarAlt,
  faUsers,
  faChild,
  faCloud,
  faPlus,
  faPaperPlane,
  faArrowLeft,
  faTimes,
  faIdCard,
  faTrashAlt,
  faDownload
);

const App = () => {
  return (
    <GlobalProvider>
      <ToastContainer />
      <Router>
        <Switch>
          <PrivateRoute exact path="/" component={Dashboard} />
          <PrivateRoute exact path="/articles" component={Articles} />
          <PrivateRoute exact path="/articles/create" component={ArticleCreate} />
          <PrivateRoute exact path="/articles/edit/:id" component={ArticleEdit} />
          <PrivateRoute exact path="/downloads" component={Downloads} />
          <PrivateRoute exact path="/jobs" component={Jobs} />
          <PrivateRoute exact path="/jobs/create" component={JobCreate} />
          <PrivateRoute exact path="/jobs/edit/:id" component={JobEdit} />
          <PrivateRoute exact path="/media" component={Media} />
          <PrivateRoute exact path="/members" component={Members} />

          <Route exact path="/login" component={Login} />

          <PrivateRoute component={Error} />
        </Switch>
      </Router>
    </GlobalProvider>
  );
};

export default App;
